<template>
  <div class="index-container">
    <img v-if="type == 1" src="../assets/img/welcome-new.png" class="welcome-bg"/>
    <img v-else src="../assets/img/school-video.png" class="welcome-school-video"/>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      type: 1 // 1-亲小禾 2-幼儿视频
    }
  },
  created() {
    this.type = this.$route.query.type
    if (this.type == 1) {
      location.href = 'weixin://dl/business/?t=zTtQdLbCnom'
    } else {
      location.href = 'weixin://dl/business/?t=ulsP182HOTl'
    }
  }
}
</script>

<style scoped>
.index-container{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}
.welcome-bg {
  position: absolute;
  width: 60%;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.welcome-school-video {
  position: absolute;
  width: 80%;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>